import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../auth-service/auth.service';
import { Roles } from '../../constants/menu-item';

// Runs after authGuard on the parent route, so the profile (and role) is cached.
// UI-side only: the admin-users Edge Function re-checks the role server-side.
export const adminGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.getUserRole() === Roles.ADMIN) {
    return true;
  }

  return router.createUrlTree(['/reports/summary']);
};
